import { BRAND } from "../constants";

export default function Footer() {
  return (
    <div style={{
      borderTop: "1px solid #E8E3DD",
      padding: "24px 20px",
      textAlign: "center",
    }}>
      <div style={{ fontSize: "13px", color: "#999", lineHeight: 1.6 }}>
        <strong style={{ color: "#777" }}>Step Up for Teachers</strong> is an initiative of the{" "}
        <a href="https://www.decatureducationfoundation.org" target="_blank" rel="noopener"
          style={{ color: BRAND.primary, textDecoration: "none" }}>
          Decatur Education Foundation
        </a>
      </div>
      <div style={{ fontSize: "12px", color: "#BBB", marginTop: "6px" }}>
        Enabling the full potential of Decatur's young people since 2000
      </div>
      <div style={{ fontSize: "12px", color: "#BBB", marginTop: "6px" }}>
        Questions? <a href="mailto:info@decatureducationfoundation.org" style={{ color: "#999", textDecoration: "none" }}>info@decatureducationfoundation.org</a>
      </div>
    </div>
  );
}
